import {Injectable} from '@angular/core'
import {UserService} from '../services/UserService';
import {LocalesService} from '../services/LocalesService';
import {FranquiciasService} from '../services/FranquiciasService';

@Injectable()

export class Franquiciados {

  user: any;

  constructor(
    private userService: UserService,
    private localesService: LocalesService,
    private franquiciasService: FranquiciasService,
  ) {
  }


  /**
   * Obtener los franquiciados y los locales si tiene el permiso
   *
   */
  getFranchiseeWithLocals() {

    return new Promise(async (resolve) => {

      this.user = this.userService.get();

      const locals = this.localesService.get() || [];
      const franchisee = this.franquiciasService.get() || [];

      if (!this.user.permisos.application.auditorias_franquicia.ver) {
        resolve(locals);
        return;
      }

      resolve([...locals, ...franchisee])

    });

  }

}



// WEBPACK FOOTER //
// ./src/classes/franquiciados.ts